import React from 'react';
import { 
  HeroSection, 
  ServiceCategories, 
  FeaturedVendors,
  VendorSpotlight,
  VendorServices,
} from '../../components/home';
import CategoryServicesSkeleton from '../../components/shared/CategoryServicesSkeleton';
import { useHomeCategories } from '../../hooks/useHomeCategories';
import { useCategoryServices } from '../../hooks/useCategoryServices';
import useUserLocation from '../../hooks/useUserLocation';

// Component to render vendor services for a category
const CategoryVendorServices = ({ category, className = '', priceLabel = 'starting from', linkPrefix, userLocation }) => {
  const { services, isLoading, error } = useCategoryServices(category.id, {
    location: userLocation
  });

  return (
    <VendorServices 
      title={category.category_name || 'Services'}
      data={services}
      isLoading={isLoading}
      error={error}
      categorySlug={category.id}
      linkPrefix={linkPrefix || '/services'}
      priceLabel={priceLabel}
      className={className}
      emptyMessage={`No ${category.category_name?.toLowerCase()} services available`}
      emptyDescription="Check back later for new services"
    />
  );
};

const ClientHome = () => {
  const { categories, isLoading: categoriesLoading } = useHomeCategories();
  const { userLocation } = useUserLocation();

  // Debug: Log location changes
  React.useEffect(() => {
    // console.log('ClientHome: userLocation changed:', userLocation);
  }, [userLocation]);

  return (
    <>
      <HeroSection />
      <div className="overflow-hidden">
        <ServiceCategories />
        <FeaturedVendors />
        
        {categoriesLoading ? (
          <CategoryServicesSkeleton sections={3} />
        ) : (
          <>
            {categories.length > 0 ? (
              <>
                {/* Render vendor services for each category */}
                {categories.map((category, index) => {
                  // Insert VendorSpotlight after the 3rd category
                  const shouldShowSpotlight = index === 3 && categories.length > 3;
                  
                  return (
                    <React.Fragment key={category.id}>
                      <CategoryVendorServices
                        category={category}
                        className={index % 2 === 1 ? 'bg-gray-50' : ''}
                        priceLabel={index === 0 ? 'starting from' : 'starting from'}
                        linkPrefix="/services"
                        userLocation={userLocation}
                      />
                      {shouldShowSpotlight && <VendorSpotlight />}
                    </React.Fragment>
                  );
                })}
                
                {/* Show VendorSpotlight at the end if we have 3 or fewer categories */}
                {categories.length <= 3 && <VendorSpotlight />}
              </>
            ) : (
              <>
                {/* No categories available */}
                <VendorSpotlight />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ClientHome;